import type { RouteObject } from 'react-router-dom';
import Wrapper from './pages/Wrapper';
import ErrorPage from './pages/Error';
import Home from './pages/Home';
import Contact from './pages/Contact';

/* Route config shared between the client (createBrowserRouter, in main.tsx)
   and the build-time prerender (createStaticHandler, in entry-server.tsx),
   so both render an identical tree. */
export const routes: RouteObject[] = [
  {
    path: '/',
    element: <Wrapper />,
    errorElement: <ErrorPage key="error-page" />,
    children: [
      { index: true, element: <Home key="home-page" /> },
      { path: 'contact', element: <Contact key="contact-page" /> }
    ]
  }
];
